// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'MAIN MENU',
    items: [
      {
        title: 'Dashboard',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
        subTitle: 'Dashboard'
      }
      // { title: 'e-commerce', path: PATH_DASHBOARD.general.ecommerce, icon: ICONS.ecommerce },
      // { title: 'analytics', path: PATH_DASHBOARD.general.analytics, icon: ICONS.analytics },
      // { title: 'banking', path: PATH_DASHBOARD.general.banking, icon: ICONS.banking },
      // { title: 'booking', path: PATH_DASHBOARD.general.booking, icon: ICONS.booking }
    ]
  },
  {
    subheader: 'Workspace',
    items: [
      // MANAGEMENT : USER
      // {
      //   title: 'Accounts',
      //   path: PATH_DASHBOARD.task.newUser,
      //   icon: ICONS.user,
      //   subTitle: 'ADD TEAM MEMBERS',
      //   children: [
      //     // { title: 'profile', path: PATH_DASHBOARD.user.profile },
      //     // { title: 'cards', path: PATH_DASHBOARD.user.cards },
      //     // { title: 'list', path: PATH_DASHBOARD.user.list },
      //     { title: 'create', path: PATH_DASHBOARD.user.newUser }
      //     // { title: 'edit', path: PATH_DASHBOARD.user.editById },
      //     // { title: 'account', path: PATH_DASHBOARD.user.account }
      //   ]
      // },
      {
        title: 'Merchants',
        path: PATH_DASHBOARD.merchant.root,
        icon: ICONS.cart,
        subTitle: 'MERCHANTS'
      },
      {
        title: 'Users',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        subTitle: 'USER MANAGEMENT'
      }
    ]
  },
  {
    subheader: 'Administration',
    items: [
      {
        title: 'Admin Accounts',
        path: PATH_DASHBOARD.adminAccount.root,
        icon: ICONS.user,
        subTitle: 'CMS ADMIN MANAGEMENT',
        info: (
          <Label variant="filled" color="error" sx={{ fontSize: 10 }}>
            ADMIN
          </Label>
        )
      },
      {
        title: 'Subscription Plans',
        path: PATH_DASHBOARD.subscriptionPlans.root,
        icon: ICONS.ecommerce,
        subTitle: 'PRICING MATRIX'
      },
      {
        title: 'Audit Campaigns',
        path: PATH_DASHBOARD.auditCampaigns.root,
        icon: ICONS.analytics,
        subTitle: 'OUTSCRAPER STORE AUDIT'
      },
      {
        title: 'Prompt Templates',
        path: PATH_DASHBOARD.auditCampaigns.prompts,
        icon: ICONS.blog,
        subTitle: 'DEFAULT AUDIT PROMPTS'
      }
    ]
  },
  {
    subheader: 'Messaging',
    items: [
      {
        title: 'Bulk SMS',
        path: PATH_DASHBOARD.bulkSms.root,
        icon: ICONS.mail,
        subTitle: 'BULK SMS (FLOW)'
      },
      {
        title: 'SMS Wallet',
        path: PATH_DASHBOARD.smsWallet.root,
        icon: ICONS.banking,
        subTitle: 'WALLET MANAGEMENT'
      },
      {
        title: 'SMS Campaigns',
        path: PATH_DASHBOARD.smsCampaign.root,
        icon: ICONS.mail,
        subTitle: 'CAMPAIGN MANAGEMENT'
      },
      {
        title: 'SMS Overage Billing',
        path: PATH_DASHBOARD.smsOverageBilling.root,
        icon: ICONS.banking,
        subTitle: 'OVERAGE BILLING'
      }
    ]
  },
  {
    subheader: 'Settings',
    items: [
      {
        title: 'Industries',
        path: PATH_DASHBOARD.settings.industries,
        icon: ICONS.ecommerce,
        subTitle: 'INDUSTRY MANAGEMENT'
      },
      {
        title: 'Default Links',
        path: PATH_DASHBOARD.settings.defaultLinks,
        icon: ICONS.ecommerce,
        subTitle: 'DEFAULT INSTRUCTION LINKS'
      }
    ]
  }
];

export default sidebarConfig;
